import { Image, Select } from 'antd'
import { useSelector } from 'react-redux'

const { Option } = Select

function CountryCodeChevron() {
  return (
    <span className='country-code-select__chevron' aria-hidden='true'>
      <svg width='12' height='8' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M9 1L5 5L1 1'
          stroke='currentColor'
          strokeWidth='1.7'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  )
}

const SelectCountryCodes = ({ value, setValue, className = '!bg-[#F2F2F2]' }) => {
  const { countries = [] } = useSelector((state) => state.countries) || {}

  return (
    <Select
      className={`country-code-select ${className}`}
      showSearch
      id='status'
      suffixIcon={<CountryCodeChevron />}
      value={value}
      optionFilterProp='children'
      filterOption={(input, option) => {
        const sanitizedInput = input.startsWith('+') ? input.slice(1) : input
        return (option?.value ?? '').includes(sanitizedInput)
      }}
      onChange={(value, option) => setValue(value, option)}
    >
      {countries.map((country) => (
        <Option
          key={country.id}
          value={country.country_code}
          shortName={country.short_name}
        >
          <div className='flex items-center gap-8'>
            <Image
              width={24}
              height={16}
              alt={country.short_name}
              src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${country.short_name}.svg`}
            />
            +{country.country_code}
          </div>
        </Option>
      ))}
    </Select>
  )
}

export default SelectCountryCodes
